import { useTransition } from 'react';

import { Button, type ButtonSize, type ButtonVariant } from '@psspl/ui';

import { useAuth } from '../../auth/auth-context';
import { LOGOUT_ICON } from './navigation-items';

export interface SignOutButtonProps {
  readonly variant?: ButtonVariant;
  readonly size?: ButtonSize;
  readonly className?: string | undefined;
}

/**
 * The one sign-out control, used by the header, the mobile menu and the profile.
 *
 * It only asks the auth provider to log out. The route guard then redirects
 * to sign-in, so no caller navigates by hand. `useTransition` holds the pending state
 * for the logout request, which stops a double click from sending it twice.
 */
export function SignOutButton({ variant = 'ghost', size = 'sm', className }: SignOutButtonProps) {
  const { logout } = useAuth();
  const [isPending, startTransition] = useTransition();

  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      isLoading={isPending}
      leadingIcon={LOGOUT_ICON}
      onClick={() => {
        startTransition(async () => {
          await logout();
        });
      }}
    >
      Logout
    </Button>
  );
}
